/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// src/components/RequireRole.jsx
import React from "react";
import { useAuth } from "../auth/AuthProvider";
import { Navigate } from "react-router-dom";

export default function RequireRole({ role, roles = [], children }) {
  const { hasRole, hasAnyRole, isLoading } = useAuth();

  // Normalize single `role` prop into array
  const requiredRoles = role ? [role] : roles;

  if (isLoading) return <div>Loading...</div>;
  if (!hasAnyRole(requiredRoles)) return <Navigate to="/unauthorized" replace />;

  return children;
}